module.exports = __webpack_public_path__ + "static/media/marriage-1.9033a718.jpg";